import Ajax from '../common/ajax'

export default {
  model: 'office',
  getAgentList (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/list`, queryParam)
  },
  getAgent (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/office/listAgent`, queryParam)
  },
  getPageList (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/page`, queryParam)
  },
  getAudit (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/audit`, queryParam)
  },
  getDetail (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/detail/${id}`)
  },
  getOfficeNo (queryParam = {}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/setOfficeNo`, queryParam)
  },
  getDel (id) {
    return Ajax.del(`/api/gradeMaster/v1/${this.model}/delete/${id}`)
  },
  getOfficeUpdate (queryParam = {}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/update`, queryParam)
  },
  DisableOffice (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/disableOffice/${id}`)
  },
  EnableOffice (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/enableOffice/${id}`)
  },
  importOffice (data) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/importOffice`, data)
  },
  exportOffice (data) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/exportOffice`, data)
  }
}
